<div style="padding-bottom: 16px;">
    <div class="repeat-section">

        <div class="d-flex flex-column justify-content-center section2">
            <div class="eac-body-2 valign-center" style=" min-height: 36px; width: 80%;">
                {{metadata().name}} 
            </div>
            <div class=" valign-center eac-c1 ">
                <quill-view-html [content]="metadata().description"></quill-view-html>

            </div>
            
        </div>

        <div *ngFor="let field of field.fieldGroup; let i = index;" class="row2 ">
            <div class="col-sm-12">
                <div *ngIf="i!=0" class="section2"></div>                
                <div class="d-flex section2ww">
                    
                    <div class="valign-center mat-body-strong" style="min-height: 36px; padding-bottom: 16px; padding-top: 16px;">{{to.label}} núm. {{i+1}}
                    </div>
                    
                    <div style="flex: 1 1 0"></div>
                    
                    <button *ngIf="metadata().atLeastOne == null || metadata().atLeastOne == false || (metadata().atLeastOne==true &&i>0) " mat-icon-button type="button" (click)="remove(i)" matTooltip="Esborrar" class="btn btn-default">
                        <mat-icon class="material-icons-outlined">delete</mat-icon>
                    </button>
                </div>

                <div style="padding-top: 16px;">
                    <formly-field [field]="field"></formly-field>
                </div>
            </div>

        </div>
        
        <mat-divider *ngIf="field.fieldGroup!= null&&field.fieldGroup.length>0"></mat-divider>
        <div class="d-flex justify-content-start notprint " style="margin-bottom: 10px;">

            <div style="padding-top: 8px;">
                <div  (click)="add($event)" class="d-flex align-items-center add-repeat " style="gap:8px;">
                    <mat-icon style="font-size: 18px; height: 18px; width: 18px;  ">add</mat-icon>
                    <span class="valign-center mat-body-strong" style="padding-left: 4px;">{{metadata().addLabel}}</span>
                </div>
            </div>
            
        </div>
    </div>
</div>